import styled from "styled-components"
import { Container, Typography } from "components"
import { Card } from '@material-ui/core';

export const PreassessmentQuizLayout = styled(Container.Grid)`
  background-color: #E5E5E5;
`
